<div id="id-section-{{controlName}}" class="form-group border-box"
  [ngClass]="{'form-group-error': errorMessage !== null && formSubmitted === true}">
  <label class="form-label-b19" for="id-{{controlName}}"> {{label}} <span>{{optional}}</span></label>
  <div *ngIf="hint" id="id-section-help-{{controlName}}" class="form-hint">{{hint}}</div>
  <div *ngIf="errorMessage !== null && formSubmitted === true" id="id-section-error-{{controlName}}" data-validation-error=""
    class="form-error error-message">{{errorMessage}} <span *ngIf="!fromContext">{{label | lowercase}}</span></div>
  <ng-content></ng-content>
</div>